import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@/contexts/ThemeContext';
import styles from './ThemeSwitcher.module.css';

/** Seletor de tema (chips) + alternância light/dark. Feature do produto. */
export default function ThemeSwitcher() {
  const { themes, themeCode, mode, selectTheme, toggleMode } = useTheme();
  const { t } = useTranslation();

  return (
    <div className={styles.wrap}>
      <span className="kicker">{t('common.theme')}</span>
      <div className={styles.chips}>
        {themes.map((theme) => (
          <button
            key={theme.code}
            className={styles.chip}
            data-active={theme.code === themeCode}
            onClick={() => selectTheme(theme.code)}
          >
            {theme.name}
          </button>
        ))}
      </div>
      <button className={styles.mode} onClick={toggleMode} aria-label="toggle light/dark">
        {mode === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
        <span>{mode === 'dark' ? t('common.light') : t('common.dark')}</span>
      </button>
    </div>
  );
}
